// Sprint 35.0 — Registro del Service Worker (solo en build de PRODUCCIÓN).
// En desarrollo NO se registra para no interferir con el hot-reload del dev server.
// El SW lo genera Workbox (GenerateSW vía craco) como /service-worker.js y precachea el App Shell.

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        reg.onupdatefound = () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // Nueva versión disponible; se aplicará en la próxima recarga.
              console.info("[SW] Nueva versión del App Shell descargada.");
            }
          };
        };
      })
      .catch((err) => console.warn("[SW] Registro fallido:", err));
  });
}
